import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Card,
  Grid,
  Button,
  Tooltip,
  TextField,
  Typography,
  CardContent,
  IconButton,
  DialogActions
} from "@mui/material";
import {
  DataGrid,
  esES,
  GridActionsCellItem,
  GridToolbar,
} from "@mui/x-data-grid";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import Autocomplete from "@mui/material/Autocomplete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import DeleteDialog from "../app/common/DeleteDialog";
import RenderStatus from "../app/common/RenderStatus";
import { ModalComponent } from "../app/common/ModalComponent";
import FormDestinos from "../components/destinos/FormDestinos";
import { Status } from "../app/util/constants";
import { RootStoreContext } from "../app/store/root";
import { account } from "../shared/Utils";
import { Menu, Acciones } from "../app/util/permisos";
import { useNavigate } from "react-router-dom";
import NoRowsInDataGrid from "../shared/components/NoRowsInDataGrid";
import NoResultsInDataGrid from "../shared/components/NoResultsInDataGrid";
import CloseIcon from "@mui/icons-material/Close";

const DestinosPages = () => {
  const navigate = useNavigate();
  const rootStore = useContext(RootStoreContext);
  const {
    filter,
    entities,
    create,
    update,
    setFilter,
    activeOrInActive,
    deleteDestino,
    getAll,
    getAllByFilter,
  } = rootStore.destinoStore;

  const { setRowDelete } = rootStore.deleteStore;
  /* UseStates */
  const [model, setModel] = useState(undefined);
  const [providers, setProviders] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalProvider, setOpenModalProvider] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizeProvider, setPageSizeProvider] = useState(5);

  const [idDestino, setIdDestino] = useState(0);
  const [permisosUsuario, setPermisosUsuario] = useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  /* End UseStates */

  useEffect(() => {
    document.title = "Lilofy | Destinos";
    if (
      !account
        .getPermisosUsuario()
        .some((a) => a.clavePermiso == Menu.Destinos && a.tienePermiso)
    ) {
      navigate("/Usuarios/AccessDenied");
    } else {
      setPermisosUsuario(account.getPermisosUsuario());
      getAll();
      setFilter(Status[0]);
    }
  }, []);

  /* Methods */
  const updateDestino = (params) => {
    const row = toJS(params.row);
    if (row && Object.keys(row).length > 0) {
      console.log({ row })
      setModel(row);
      setOpenModal(true);
    }
  };
  const clearFormModel = () => {
    setOpenModal(false);
    setModel(undefined);
  };
  const clearDeleteModel = () => {
    setIdDestino(0);
    setRowDelete(undefined);
    setShowDeleteDialog(false);
  };
  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setOpenModal(false);
    setModel(undefined);
  };

  const handleCloseProvider = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setOpenModalProvider(false);
    setProviders([])
  };

  const showProviders = (params) => {
    const row = toJS(params.row);
    if (row && Object.keys(row).length > 0) {
      console.log({ row })
      setProviders(row.idProveedor)
      setPageSizeProvider(5)
      setOpenModalProvider(true)
    }
  };

  /* End Methods */

  const columns = [
    {
      headerName: "Detalle proveedor",
      minWidth: 120,
      maxWidth: 120,
      flex: 0.5,
      sortable: false,
      type: "actions",
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">
          Detalle proveedor
        </span>
      ),
      getActions: (params) => [
        <Tooltip title="Proveedores" placement="top">
          <GridActionsCellItem
            icon={<FindInPageIcon />}
            label="Proveedores"
            color="primary.main"
            onClick={() => showProviders(params)}
            renderCell={() => showProviders(params)}
          />
        </Tooltip>
      ]
    },
    {
      field: "nombreEmpresaDestino",
      headerName: "Nombre empresa de destino",
      minWidth: 150,
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">
          Nombre empresa de destino
        </span>
      ),
    },
    {
      field: "rfc",
      headerName: "RFC",
      minWidth: 150,
      flex: 1,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">
          RFC
        </span>
      ),
    },
    {
      field: "direccion",
      headerName: "Dirección",
      sortable: false,
      minWidth: 200,
      flex: 0.5,
      headerClassName: "tableHeaders",
      renderHeader: () => (
        <span className="headerTable">
          Dirección
        </span>
      ),
    },
    {
      field: "idEstatus",
      headerName: "Estatus",
      sortable: false,
      renderCell: (row) => (
        <RenderStatus
          Row={row}
          FieldName="destino"
          NameRow={row.row.nombreEmpresaDestino}
          MessageWhenInactive=": Si hace esto los usuarios ya no podrán seleccionar este destino para realizar guías."
          PermisoEditar={permisosUsuario.some(
            (a) =>
              a.clavePermiso === Acciones.Editar_estatus_destino &&
              a.tienePermiso
          )}
          OnFinish={(idEstatus) => {
            activeOrInActive(row.row.idDestino);
          }}
        />
      ),
      renderHeader: () => (
        <span className="headerTable">
          Estatus
        </span>
      ),
      minWidth: 200,
      flex: 0.5,
      headerClassName: "tableHeaders",
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Acciones",
      headerClassName: "tableHeaders",
      getActions: (params) => [
        <Tooltip title="Editar" placement="top">
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Editar"
            color="primary.main"
            hidden={
              !permisosUsuario.some(
                (a) =>
                  a.clavePermiso === Acciones.Editar_destino && a.tienePermiso
              )
            }
            onClick={() => updateDestino(params)}
            renderCell={() => updateDestino(params)}
          />
        </Tooltip>,
        <Tooltip title="Eliminar" placement="top">
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Eliminar"
            color="primary.main"
            hidden={
              !permisosUsuario.some(
                (a) =>
                  a.clavePermiso === Acciones.Eliminar_destino && a.tienePermiso
              )
            }
            onClick={() => {
              const row = toJS(params.row);
              if (row && Object.keys(row).length > 0) {
                setRowDelete({
                  NameRow: row.nombreEmpresaDestino,
                  MessageWhenDelete:
                    "Si hace esto los usuarios ya no podrán seleccionar este destino para realizar guías.",
                });
                setIdDestino(row.idDestino);
                setShowDeleteDialog(true);
              }
            }}
          />
        </Tooltip>,
      ],
    },
  ];

  return (
    <>
      <div className="main-container">
        <div className="mb-2">
          <Typography color="primary" variant="h4">
            <LocationOnIcon sx={{ marginRight: 2 }} fontSize="large" />
            Destinos
          </Typography>
        </div>
        <Card className="card">
          <CardContent>
            <Grid
              container
              direction={"row"}
              justifyContent="end"
              alignItems={"center"}
            >
              <Grid item>
                {permisosUsuario.some(
                  (a) =>
                    a.clavePermiso === Acciones.Alta_destino && a.tienePermiso
                ) && (
                    <Button
                      onClick={() => {
                        setOpenModal(true);
                        setModel(undefined);
                      }}
                      variant="contained"
                    >
                      Nuevo destino
                    </Button>
                  )}
              </Grid>
            </Grid>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              direction={"row"}
              alignItems={"center"}
              mb={1}
            >
              <Grid item xs="12" sm="6" md="3" lg="2">
                {/* <SelectSearchComponent
                  Value={filter}
                  OnChange={(e) => {
                    setFilter(e.target.value);
                  }}
                  Placeholder="Estatus"
                  Options={{ options: Status }}
                /> */}
                <Autocomplete
                  size="small"
                  value={filter}
                  options={Status}
                  id="combo-box-destinos"
                  sx={{ width: "100%" }}
                  onChange={(event, value) => {
                    setFilter(value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Estatus" />
                  )}
                />
              </Grid>

              <Grid item>
                <Button
                  onClick={() => {
                    getAllByFilter(
                      filter?.value !== 1 ? { IdEstatus: filter?.value } : {}
                    );
                  }}
                  variant="contained"
                >
                  Buscar
                </Button>
              </Grid>
            </Grid>

            <Box
              sx={{
                width: "100%",
                "& .tableHeaders": {
                  color: "primary.main",
                },
                marginBottom: "1rem",
                marginTop: "0.5rem",
              }}
            >
              <DataGrid
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                autoHeight
                rows={entities}
                columns={columns}
                dataSource={entities}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[5, 10, 20]}
                pagination
                disableColumnFilter
                disableColumnSelector
                disableDensitySelector
                components={{
                  Toolbar: GridToolbar,
                  NoRowsOverlay: () => <NoRowsInDataGrid />,
                  NoResultsOverlay: () => <NoResultsInDataGrid />,
                }}
                getRowId={(row) => row.idDestino}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                    csvOptions: { disableToolbarButton: true },
                    printOptions: { disableToolbarButton: true },
                  },
                }}
              />

            </Box>
          </CardContent>
        </Card>
      </div>
      <ModalComponent
        Open={openModal}
        HandleClose={handleClose}
        ClassName="modal-xl"
        Body={() => (
          <FormDestinos
            data={model}
            onFinish={(data) => {
              if (!data.idDestino) {
                data.idProveedor = data.idProveedor.filter(a => a.id != '-1').map(a => { return { id: a.id, label: a.label } })
                create(data).then(
                  () => {
                    clearFormModel();
                  },
                  (err) => { }
                );
              } else {
                data.idProveedor = data.idProveedor.filter(a => a.id != '-1').map(a => { return { id: a.id, label: a.label } })
                update(data).then(
                  () => {
                    clearFormModel();
                  },
                  (err) => { }
                );
              }
            }}
            onClose={handleClose}
          />
        )}
      />
      <ModalComponent
        Open={openModalProvider}
        HandleClose={handleCloseProvider}
        ClassName="modal-lg"
        Body={() => (
          <div>
            <Grid container spacing={3} mb={2}>
              <Grid item xs>
                <h2 style={{ fontSize: 14 }}>
                  <strong>Proveedores</strong>
                </h2>
              </Grid>
              <Grid item xs={6} />
              <Grid item xs>
                <div style={{ position: "relative" }}>
                  <IconButton
                    aria-label="close"
                    onClick={() => {
                      setOpenModalProvider(false)
                    }}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </Grid>
            </Grid>
            <Box noValidate component="form">              
                <Grid item mb={2}>                  
                    <DataGrid
                      localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                      autoHeight
                      rows={providers}
                      columns={[
                        {
                          field: "label",
                          headerName: "Proveedor",
                          minWidth: 150,
                          flex: 1,
                          headerClassName: "tableHeaders",
                          renderHeader: () => (
                            <span className="headerTable">
                              Proveedor
                            </span>
                          ),
                        }
                      ]}
                      dataSource={providers}
                      pageSize={pageSizeProvider}
                      onPageSizeChange={(newPageSize) => setPageSizeProvider(newPageSize)}
                      rowsPerPageOptions={[5, 10]}
                      pagination
                      disableColumnFilter
                      disableColumnSelector
                      disableDensitySelector
                      getRowId={(row) => row.id}
                    />                    
                </Grid>
            </Box>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              mt={2}
            >
              <Button
                type="submit"
                onClick={() => {
                  setOpenModalProvider(false)
                }}
                variant="contained"
                style={{ marginLeft: 10 }}
              >
                Aceptar
              </Button>
            </Grid>
          </div>
        )}
      />
      <DeleteDialog
        Open={showDeleteDialog}
        FieldName="el destino"
        OnClose={() => {
          clearDeleteModel();
        }}
        OnFinish={() => {
          deleteDestino(idDestino).then(() => {
            clearDeleteModel();
          });
        }}
      />
    </>
  );
};

export default observer(DestinosPages);
